module.exports = __webpack_public_path__ + "static/s1-54d39f6388e6caf1faf92b47b613159a.jpg";